<template>
  <section class="wrapper">
    <van-row class="mt10" :gutter="5">
      <van-col :span="8">
        <van-button block size="small" :type="currentUrl==='material-regist'?'primary':'default'"
                    @click="goto('material-regist')">材料采购登记
        </van-button>
      </van-col>
      <van-col :span="8">
        <van-button block size="small" :type="currentUrl==='asset-regist'?'primary':'default'"
                    @click="goto('asset-regist')">
          资产采购登记
        </van-button>
      </van-col>
      <van-col :span="8">
        <van-button block size="small" :type="currentUrl==='product-cancel'?'primary':'default'"
                    @click="goto('product-cancel')">
          商品生产与核销登记
        </van-button>
      </van-col>
    </van-row>
    <van-row class="mt10" :gutter="5">
      <van-col :span="8">
        <van-button block size="small" :type="currentUrl==='search-material'?'primary':'default'"
                    @click="goto('search-material')">
          材料查询与处置
        </van-button>
      </van-col>
      <van-col :span="8">
        <van-button block size="small" :type="currentUrl==='search-asset'?'primary':'default'"
                    @click="goto('search-asset')">
          资产查询与处置
        </van-button>
      </van-col>
      <van-col :span="8">
        <van-button block size="small" :type="currentUrl==='setting-type'?'primary':'default'"
                    @click="goto('setting-type')">
          商品与资产类别设置
        </van-button>
      </van-col>
    </van-row>
    <van-row class="mt10" :gutter="5">
      <van-col :span="8">
        <van-button block size="small" :type="currentUrl==='setting-name'?'primary':'default'"
                    @click="goto('setting-name')">
          产品与资产名称设置
        </van-button>
      </van-col>
    </van-row>
    <router-view class="content"></router-view>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        currentUrl: ''
      }
    },
    methods: {
      goto(url) {
        this.$router.push(`/material/${url}`)
      }
    },
    watch: {
      $route: {
        handler(to, from) {
          const urlArray = to.path.split('/');
          this.currentUrl = urlArray[urlArray.length - 1];
        },
        immediate: true
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    padding: 0 1rem;
    overflow: hidden;

    .content {
      margin-top: 1rem;
      display: flex;
      flex-direction: column;
      height: calc(100% - 20rem);
      overflow: auto;
    }
  }
</style>
